







import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'

@Component
export default class Info extends Vue {
  private apiInfo = {
    version: '--',
    commitHash: '--'
  }

  private uiInfo = {
    version: process.env.VUE_APP_UI_VERSION?.split('-')[0] || 0,
    commitHash: process.env.VUE_APP_COMMIT_HASH?.substring(0, 6) || 0
  }

  created() {
    ApiClient.getInfo()
      .then(info => {
        this.apiInfo = info || this.apiInfo
      })
  }
}
